import I18N from '@leverege/i18n';
import PieChartContainerView from "./PieChartContainerView.js";
import PieChartViewModel from "./models/PieChartViewModel.js";
import DataViewerModelUpdaterCreator from "../DataViewerModelUpdaterCreator.js";
import DataViewerModel from "../DataViewerModel.js";
import PieChartSupportDataViewer from "./PieChartSupportDataViewer.js";
const {
  tf,
  tfIcon
} = I18N.ns('molten.dataViewers.pieChart.PieChartDataViewer');
export default {
  id: 'molten.dataViewers.pieChart.PieChartDataViewer',
  type: 'molten.PieChartContainer',
  name: tf('pieChartViewer'),
  icon: tfIcon('configIcon'),
  layout: {
    section: tf('section'),
    sort: 'c.c'
  },
  location: ['main', 'card'],
  matches: {
    type: 'GroupDataViewer'
  },
  settingsUpdaters: DataViewerModelUpdaterCreator.create('PieChartViewModelUpdater'),
  createSettings: props => {
    return PieChartViewModel.create({
      dataViewers: [DataViewerModel.create(PieChartSupportDataViewer.type, PieChartSupportDataViewer.createSettings(props))],
      breakpoints: []
    });
  },
  component: PieChartContainerView,
  getDefaultCardContentOptions: {
    height: '400px'
  }
};